import i18next from 'i18next';

export const DownloadStatus = Object.freeze({
    IN_PROGRESS: 'IN_PROGRESS',
    READY: 'READY',
    FAILED: 'FAILED',
    DOWNLOADED: 'DOWNLOADED',
});

export const DownloadStatusTranslations = Object.freeze({
    [DownloadStatus.READY]: gettext('READY'),
    [DownloadStatus.IN_PROGRESS]: gettext('IN_PROGRESS'),
    [DownloadStatus.FAILED]: gettext('FAILED'),
    [DownloadStatus.DOWNLOADED]: gettext('DOWNLOADED'),
});

export const DownloadCategory = Object.freeze({
    REPORT: 'REPORT',
    DATA_EXPORT: 'DATA_EXPORT',
});

export const DownloadCategoryTranslations = Object.freeze({
    [DownloadCategory.REPORT]: gettext('REPORT'),
    [DownloadCategory.DATA_EXPORT]: gettext('DATA_EXPORT'),
});

export const NotificationLevel = Object.freeze({
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
});

export const NotificationLevelTranslations = Object.freeze({
    [NotificationLevel.SUCCESS]: i18next.t('Success'),
    [NotificationLevel.INFO]: i18next.t('Info'),
    [NotificationLevel.WARNING]: gettext('WARNING'),
    [NotificationLevel.ERROR]: i18next.t('Error'),
});

export const NotificationBorderVariants = Object.freeze({
    [NotificationLevel.SUCCESS]: 'border-l-notification-success',
    [NotificationLevel.INFO]: 'border-l-notification-info',
    [NotificationLevel.WARNING]: 'border-l-notification-warning',
    [NotificationLevel.ERROR]: 'border-l-notification-error',
});
